<template>
  <page-loader v-if="loadStatus == 'loading'" />
  <div v-else class="contain-section px-0">
    <div class="row">
      <div class="col-sm-12 px-0">
        <div class="inner-box">
          <div class="map-detail-section">
            <div class="col-sm-12">
              <h2 class="fw-bold text-blk fs-3 text-start mb-3 mb-sm-3">
                Neanderthal Results
              </h2>
            </div>
            <div class="col-sm-12">
              <div class="row archai-result-grid-row">
                <div class="col-md-12 col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                  <div class="result-detail apply-box-shadown">
                    <div class="left">
                      <h4 class="text-blk left-header-row">
                        Your Neanderthal <br />
                        score is
                        <a href="#" class="link fw-bold fs-2">{{
                          archaicResult.neanderthal.score
                        }}</a>
                      </h4>
                    </div>
                    <div class="percentage-area">
                      <DoughnutChart :chart-data="chartData" ChartColor="rgb(51, 119, 255)" :centerTitle="''"
                        centerSubtitle="" chartWidth="100%" chartHeight="100%" :options="options"
                        class="percentage-area-rowx" />

                      <!-- <div class="progress-wrapper">
                                                <svg class="progress-circle" viewBox="0 0 100 100">
                                                    <circle
                                                        ref="circle"
                                                        cx="50"
                                                        cy="50"
                                                        r="40"
                                                    ></circle>
                                                </svg>
                                                <svg class="progress-bar" viewBox="0 0 100 100">
                                                    <circle cx="50" cy="50" r="40"></circle>
                                                </svg>
                                                <text class="progress-text" x="50" y="50">
                                                    <b class="fw-bold">{{ 300 }}</b
                                                    ><span>Neanderthal score</span></text
                                                >
                                            </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-6">
                  <div class="row percentile-grid-row">
                    <div
                      class="col-sm-6 mb-3 mb-sm-0 bx-shadow d-flex flex-column align-items-center justify-content-center apply-box-shadown">
                      <div class="custom-card">
                        <div class="col-sm-12">
                          <!-- <img src="../../../assets/images/ancetry/icon11.png" alt="" class="img-fluid"> -->
                        </div>
                        <div class="col-sm-12">
                          <!-- <img
                            class="mb-4"
                            src="../../assets/images/Neatherland/w.png"
                            alt=""
                          /> -->
                          <div class="text-center">
                            <h3>{{ archaicResult.neanderthal.percentage }}%</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-sm-6 mb-3 mb-sm-0 bx-shadow d-flex flex-column align-items-center justify-content-center apply-box-shadown">
                      <div class="custom-card">
                        <div class="col-sm-12">
                          <!-- <img src="../../../assets/images/ancetry/icon12.png" alt="" class="img-fluid"> -->
                        </div>
                        <div class="col-sm-12">
                          <!-- <img
                            class="mb-4"
                            src="../../assets/images/Neatherland/wx.png"
                            alt=""
                          /> -->
                          <div class="text-center">
                            <h3 class="fs-size">
                              {{ archaicResult.neanderthal.closest_sample.name }}
                            </h3>
                            <label>Most Similar Remnant
                              <!-- <img
                                                            src="../../../assets/images/ancetry/inform.png"
                                                            alt=""
                                                            class="img-fluid"
                                                            @click="modal.show()"
                                                    /> -->
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 mt-3 mt-lg-5 mb-3 mb-lg-5">
                <h4 class="text-blk fs-5 fw-bolder mb-3">Percentiles by Region</h4>
                <p class="fs-14 text-blk">
                  Compare your level of Neanderthal DNA with the rest of our userbase, as
                  a whole and by region
                </p>
              </div>
              <div class="col-sm-12">
                <div class="row mb-0 mb-lg-5">
                  <div class="col-md-6 col-lg-4 mb-3 mb-md-5 text-start"
                    v-for="(percentile, region) in archaicResult.neanderthal.percentiles" :key="region">
                    <ArchaicResultsPercentile :percentile="percentile" :region="region" />
                  </div>
                  <!-- <div class="col-md-6 col-lg-4 mb-3 mb-md-5 text-start">
                                        <label class="fw-medium mb-2 text-blk"
                                            >West Eurasia -
                                            <b class="fw-bold text-blue fs-5">40%</b></label
                                        >
                                        <div>
                                            <div class="h-progress-bar">
                                                <div class="count-b completed"></div>
                                                <div class="count-b completed"></div>
                                                <div class="count-b completed"></div>
                                                <div class="count-b activate"></div>
                                                <div class="count-b"></div>
                                                <div class="count-b"></div>
                                                <div class="count-b"></div>
                                                <div class="count-b"></div>
                                                <div class="count-b"></div>
                                                <div class="count-b"></div>
                                            </div>
                                        </div>
                                    </div> -->
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <h4 class="fw-bold text-blk fs-3 text-start mb-3 mt-3 mt-lg-5">
                  Denisovan Results
                </h4>
              </div>
              <div class="col-sm-12">
                <div class="row archai-result-grid-row">
                  <div class="col-md-12 col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                    <div class="result-detail apply-box-shadown">
                      <div class="left">
                        <h4 class="text-blk left-header-row">
                          Denisovan Score <br />
                          score is
                          <a href="#" class="link fw-bold fs-2">{{
                            archaicResult.denisova.score
                          }}</a>
                        </h4>
                      </div>
                      <div class="percentage-area">
                        <DoughnutChart :chart-data="denisovaData" ChartColor="rgb(51, 119, 255)" :centerTitle="''"
                          centerSubtitle="" :options="options" chartWidth="100%" chartHeight="100%"
                          class="percentage-area-rowx" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <div class="row percentile-grid-row">
                      <div
                        class="col-sm-6 mb-3 mb-sm-0 bx-shadow d-flex flex-column align-items-center justify-content-center apply-box-shadown">
                        <div class="custom-card">
                          <div class="col-sm-12">
                            <div class="text-center">
                              <h3>{{ archaicResult.denisova.percentage }}%</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 mt-3 mt-sm-5 mb-3 mt-md-5 mb-md-5">
                <h4 class="text-blk fs-4 fw-bolder text-upper mb-3">
                  Percentiles by Region
                </h4>
                <p class="text-blk">
                  Compare your level of Neanderthal DNA with the rest of our userbase, as
                  a whole and by region
                </p>
              </div>
              <div class="col-sm-12">
                <div class="row mb-3 mb-md-4">
                  <div class="col-md-6 col-lg-4 mb-3 mb-md-5 text-start"
                    v-for="(percentile, region) in archaicResult.denisova.percentiles" :key="region">
                    <ArchaicResultsPercentile :percentile="percentile" :region="region" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 text-start">
                <h2 class="fs-3 fw-bolder text-blk mb-3 mt-3 mb-md-4 mt-md-0">
                  {{ understanding.heading }}
                </h2>

                <label class="fs-5 fw-semibold text-blk mb-3">Neanderthal Score</label>
                <p class="fs-14 lh-2 text-gry">
                  Your Neanderthal score represents the number of alleles (DNA letters)
                  that you share with Neanderthals. A total of 3,990 human genome
                  locations (SNPs) have been identified as originating in Neanderthals. By
                  multiplying this number by 2 we get the total number of alleles that we
                  calculate your Neanderthal score over; this is 7,980. Therefore,
                  Neanderthal scores range between 0 and 7,980. However, the maximum and
                  minimum scores are never found in people. Typically, scores between 250
                  to 400 likely for someone without African ancestry.
                </p>

                <label class="fs-5 fw-semibold text-blk text-start mb-3 mb-sm-3">Denisovan Score</label>
                <p class="fs-14 lh-2 text-gry">
                  Your Denisovan score represents the number of alleles (DNA letters) that
                  you share with Denisovans. A total of 817 human genome locations (SNPs)
                  have been identified as originating in Denisovans. By multiplying this
                  number by 2 we get the total number of alleles that we calculate your
                  Denisovan score over: 1,634 Therefore, Denisovan scores range between 0
                  and 1,634. Typically, the maximum score you might expect to see is 400.
                </p>

                <label class="fs-5 fw-semibold text-blk mb-3 mt-0 mt-sm-3">Percentage Value</label>
                <p class="fs-14 lh-2 text-gry">
                  The percentage value presented represents the fraction of your genome
                  estimated to have originated from Neanderthals/Denisovans.
                </p>
                <label class="fs-5 fw-semibold text-blk mb-3 mt-0 mt-sm-3">Percentiles</label>
                <p class="fs-14 lh-2 text-gry">
                  The blue bar shown in each diagram represents the proportion of the
                  corresponding population group for which your score is greater than. For
                  example, if the blue bar is to the far left it would mean that your
                  score is less than all the people in this group. Conversely, if the blue
                  bar is all the way to the right your score is greater than all the
                  people in this group. If the bar is in the middle, then your score sits
                  in the middle of the scores for people in the group.
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 mt-3 mt-lg-5">
                <h4 class="text-blk fs-5 fw-bolder mb-3 mb-lg-0 text-start text-lg-center">
                  Percentiles Regions
                </h4>
              </div>
              <div class="col-sm-12">
                <div class="row d-flex justify-content-center mt-0 mt-lg-4">
                  <div class="col-md-12 col-lg-4 text-start text-lg-center">
                    <label class="fs-5 fw-medium mb-1 mb-md-2 mb-lg-3 text-blk">Oceania</label>
                    <p class="fs-14 text-gry">
                      Native populations from Australasia, Melanesia, Micronesia, and
                      Polynesia.
                    </p>
                  </div>
                  <div class="col-md-12 col-lg-4 text-start text-lg-center">
                    <label class="fs-5 fw-medium mb-1 mb-md-2 mb-lg-3 text-blk">America</label>
                    <p class="fs-14 text-gry">
                      Native populations from North, Central and South America
                    </p>
                  </div>
                  <div class="col-md-12 col-lg-4 text-start text-lg-center">
                    <label class="fs-5 fw-medium mb-1 mb-md-2 mb-lg-3 text-blk">West Eurasia</label>
                    <p class="fs-14 text-gry">
                      Populations from Europe, the Middle East and the Caucasus regions
                    </p>
                  </div>
                </div>
                <div class="row d-flex justify-content-center mt-0 mt-lg-4">
                  <div class="col-md-12 col-lg-4 text-start text-lg-center">
                    <label class="fs-5 fw-medium mb-1 mb-md-2 mb-lg-3 text-blk">South Asia</label>
                    <p class="fs-14 text-gry">
                      Populations from India, Pakistan, Bangladesh, Bhutan, Nepal, and Sri
                      Lanka.
                    </p>
                  </div>
                  <div class="col-md-12 col-lg-4 text-start text-lg-center">
                    <label class="fs-5 fw-medium mb-1 mb-md-2 mb-lg-3 text-blk">Central and East Asia</label>
                    <p class="fs-14 text-gry">
                      Populations from Central Asia, Siberia, East Asia and continental
                      Southeast Asia
                    </p>
                  </div>
                  <div class="col-md-12 col-lg-4 text-start text-lg-center">
                    <label class="fs-5 fw-medium mb-1 mb-md-2 mb-lg-3 text-blk">Africa</label>
                    <p class="fs-14 text-gry">Populations from the African continent</p>
                  </div>
                </div>
                <div class="row d-flex justify-content-center mt-0 mt-lg-4">
                  <div class="col-md-12 col-lg-4 text-start text-lg-center">
                    <label class="fs-5 fw-medium mb-1 mb-md-2 mb-lg-3 text-blk">South Asia</label>
                    <p class="fs-14 text-gry">
                      Populations from India, Pakistan, Bangladesh, Bhutan, Nepal, and Sri
                      Lanka.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 text-start mt-4 mt-lg-5">
                <h4 class="fs-5 fw-semibold mb-3 text-blk">
                  Detailed Description of the Scoring Methods
                </h4>
                <p class="fs-14 text-gry">
                  The scoring method for both Neanderthal and Denisovan are based upon the
                  same principle: matching alleles (DNA letters) between the user and
                  Neanderthals/Denisovans over standardised sets of single nucleotide
                  polymorphisms (SNPs). Because the human genome is diploid (two copies of
                  each chromosome) each SNP describes 2 alleles. Therefore, when comparing
                  the alleles of a user to that of Neanderthal/Denisovan over a given SNP,
                  we are comparing 4 alleles; 2 alleles from the user and 2 from
                  Neanderthal/Denisovan. The score per SNP can therefore have a value of
                  0, 1, or 2. This value is then summed over the entire set of SNPs,
                  yielding the user's final score.
                </p>
                <p class="fs-14 text-gry">
                  There are 3,990 SNPs in the Neanderthal SNP set, and 817 in the
                  Denisovan set. Each set of SNPs was selected from the scientific
                  published literature as representing regions of the human genome that
                  originated either Neanderthals or Denisovans - a result of
                  introgression.
                </p>
                <p class="fs-14 text-gry">
                  The maximum possible score for a user can be 7,980 (3,990 x 2) for
                  Neanderthal and 1,634 (817 x 2) for Denisovan. However, the likelihood
                  of any user achieving this score is very small. We have calculated the
                  observed scores for many individuals in order to correctly present a
                  user’s score in context to the wider human population.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../styles/pages/ancentry/neanderthal.scss";

import { ref, onMounted, watch } from "vue";
import { getArchaicUnderstanding, getClosestSampleInfo } from "@/services/archaic";
// import PageLoader from "@/components/PageLoader.vue";
// import ArchaicResultsSectionTitle from "./ArchaicResultsSectionTitle.vue";
import ArchaicResultsPercentile from "./ArchaicResultsPercentile.vue";
// import ArchaicResultsInfoCard from "./ArchaicResultsInfoCard.vue";
// import ArchaicResultsMarkerTable from "./ArchaicResultsMarkerTable.vue";
import DoughnutChart from "@/components/charts/Doughnut.vue";
// import TextLinkRight from "@/components/TextLinkRight.vue";

export default {
  components: {
    // PageLoader,
    // ArchaicResultsSectionTitle,
    ArchaicResultsPercentile,
    // ArchaicResultsInfoCard,
    // ArchaicResultsMarkerTable,
    DoughnutChart,
    // TextLinkRight,
  },
  props: {
    archaicResult: Object,
  },
  setup(props) {
    const loadStatus = ref("loading");
    const closestSampleInfo = ref({});
    const understanding = ref({});
    const options = {
      cutout: "70%",
      radius: "100%",
      responsive: true,
    };
    onMounted(async () => {
      understanding.value = await getArchaicUnderstanding();
      watch(
        () => props.archaicResult.neanderthal.closest_sample.slug,
        async () => {
          closestSampleInfo.value = await getClosestSampleInfo(
            props.archaicResult.neanderthal.closest_sample.slug
          );
        },
        { immediate: true }
      );
      loadStatus.value = "loaded";
    });

    return { loadStatus, closestSampleInfo, options, understanding };
  },
  computed: {
    chartData() {
      return {
        datasets: [
          {
            data: [
              this.archaicResult.neanderthal.score,
              500 - this.archaicResult.neanderthal.score,
            ],
            backgroundColor: ["rgb(51, 119, 255)", "#ddd"],
          },
        ],
        labels: [],
      };
    },
    denisovaData() {
      return {
        datasets: [
          {
            data: [
              this.archaicResult.denisova.score,
              500 - this.archaicResult.denisova.score,
            ],
            backgroundColor: ["rgb(51, 119, 255)", "#ddd"],
          },
        ],
        labels: [],
      };
    },
  },
};
</script>

<style lang="scss">
.fs-14 {
  font-size: 14px;
}
</style>